<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>当前积分：{{point}}</span>
            <a-button type="primary" style="margin-left: 15px" @click="handleBuyPoint">购买积分</a-button>
        </div>
        <a-divider>购买记录</a-divider>
        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                style="width: 50%; margin-left: 25%"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

        </a-table>
    </div>
</template>

<script>

    import vendorAdminService from "../../../service/vendorAdmin";
    import moment from "moment"

    export default {
        data() {
            return {
                columns: [
                    {title: '#', width: "10%", scopedSlots: { customRender: 'serial' }},
                    {title: '购买数量',width: "15%", dataIndex: 'amount', customRender: (text) => text + "积分"},
                    {title: '余额',width: "15%", dataIndex: 'balance', customRender: (text) => text + "积分"},
                    {title: '到账时间',width: "20%", dataIndex: 'createTime', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                ],
                rows: [],
                pagination: {},

                point: 0
            }
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            handleBuyPoint() {
                const h = this.$createElement
                this.$info({
                    title: '积分购买',
                    content: h('div', {}, [
                        h('p', '您好，请联系我们的工作人员购买积分'),
                        h('br'),
                        h('p', 'tel：15500000001（张女士）'),
                    ]),
                    onOk() {},
                    okText: "知道了"
                });
            },
            fetch(params) {
                vendorAdminService.pointBuyList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.record.records

                    pagination.current = res.data.record.current
                    pagination.total = res.data.record.total
                    pagination.pageSize = res.data.record.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }

                    this.point = res.data.point
                    this.pagination = pagination
                });
            },
        }
    }
</script>

<style scoped>

</style>
